import { usingPost } from '@ocean/api'

export const userProxyAuthentication = (sessionKey: string) =>
  usingPost('session/authenticationFromProxy', { token: sessionKey }, { useProxy: true })
